// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 594 ? "about" : chunkId) + "." + {"460":"5af8e1dc","552":"47a23d4c","594":"5612dc1b","657":"6e09a938"}[chunkId] + ".css";
};